<p>move-confirmation works!</p>
